export default "__VITE_ASSET__oo522$8X__"